export var GENERIC_PROPERTY = 1;